import { ContainerModule, interfaces } from 'inversify';
import { TicketsController } from './tickets.controller';
import { TICKETS_EVENTS } from './tickets.events';
import { ITicketsController, ITicketsEvents } from './tickets.interface';
import { TICKETS_MODULE_IDS } from './tickets.types';

const TicketsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<ITicketsController>(TICKETS_MODULE_IDS.TICKETS_CONTROLLER)
    .to(TicketsController)
    .inSingletonScope();
  bind<ITicketsEvents>(TICKETS_MODULE_IDS.TICKETS_EVENTS).toConstantValue(TICKETS_EVENTS);
});

export { TicketsModule };
